import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { FavoriteApi } from '@/modules/favorite/api/favorite.api.ts';
import type { TableId } from '@/modules/common/enums/table-id.enum.ts';

export class FavoriteQueryOptions {
  static BASE_KEY = 'favorite';

  static LIST_KEY = [PriorityQueryKey.Secondary, FavoriteQueryOptions.BASE_KEY];

  static getCardList(tableId: TableId) {
    return queryOptions({
      queryKey: [...FavoriteQueryOptions.LIST_KEY, 'card', tableId],
      queryFn: (meta) => FavoriteApi.getCardList(tableId, meta.signal),
    });
  }
}
